import { http } from "@/communication";
import { bus } from "@/bus";
import { moduleFactory } from "@/store/resource";
import moment from "moment";
import Vue from "vue";

const resourceModule = moduleFactory("message");
resourceModule.state.dialogs = [];

resourceModule.actions.dialog = (
  { commit, getters, rootGetters },
  { id1, id2, shouldSkip = false }
) => {
  id1 = Number(id1);
  id2 = Number(id2);

  let dialog = getters.getDialog(id1, id2);
  let skip = 0;

  if (dialog) {
    skip = dialog.skip;

    if (shouldSkip) {
      skip += 15;
    }
  }

  dialog = {
    skip,
    id: Math.min(id1, id2) + "-" + Math.max(id1, id2),
    count: 0
  };

  commit("setDialog", dialog);

  let messagesRequest = http
    .get(`/api/v1/dialog/messages/${id1}/${id2}`, {
      params: {
        skip: dialog.skip
      }
    })
    .then(({ data }) => {
      commit("update", data);
      let customerProfile = rootGetters["user/authCustomerProfile"];
      if (customerProfile) {
        let ids = data.reduce((messageIds, message) => {
          if (message.receiver_id === customerProfile.id) {
            messageIds.push(message.id);
          }

          return messageIds;
        }, []);
        commit("user/removeUnreadMessages", ids, { root: true });
      }
    })
    .catch(error => {
      console.log(`dialogs error`, error);
    });

  let messagesCountRequest = http
    .get(`/api/v1/dialog/messages/${id1}/${id2}`, {
      params: {
        count: true
      }
    })
    .then(({ data }) => {
      commit("setDialog", {
        skip: dialog.skip,
        id: dialog.id,
        count: data
      });
    })
    .catch(error => {
      console.log(`dialogs error`, error);
    });

  return Promise.all([messagesRequest, messagesCountRequest]);
};

resourceModule.actions.readAt = ({ commit }, ids) => {
  return http.post("/api/v1/dialog/read-at", { message_ids: ids }).then(() => {
    commit("user/removeUnreadMessages", ids, { root: true });
  });
};

resourceModule.getters.dialog = state => (id1, id2) => {
  return state.messages
    .filter(message => {
      return (
        (message.sender_id === id1 && message.receiver_id === id2) ||
        (message.sender_id === id2 && message.receiver_id === id1)
      );
    })
    .sort((a, b) => {
      return moment(a.created_at).valueOf() - moment(b.created_at).valueOf();
    });
};

resourceModule.mutations.oldUpdate = resourceModule.mutations.update;
resourceModule.mutations.update = (state, resource) => {
  resourceModule.mutations.oldUpdate(state, resource);
  bus.$emit("new-message", resource);
};

resourceModule.mutations.resetSkip = (state, data) => {
  let dialog = state.dialogs.find(dialog => dialog.id === data.id);
  if (dialog) {
    dialog.skip = 0;
  }
};

resourceModule.mutations.setDialog = (state, data) => {
  let dialog = state.dialogs.find(dialog => dialog.id === data.id);

  if (dialog) {
    dialog.skip = data.skip;
    dialog.count = data.count;
  } else {
    state.dialogs.push(data);
  }
};

resourceModule.getters.getDialog = state => (id1, id2) => {
  let minId = Math.min(id1, id2);
  let maxId = Math.max(id1, id2);
  return state.dialogs.find(dialog => dialog.id === minId + "-" + maxId);
};

resourceModule.actions.oldCreate = resourceModule.actions.create;
resourceModule.actions.create = (context, data) => {
  const options = {};
  if (data.data instanceof FormData) {
    new Vue().$modal.show("upload-modal");
    context.commit("uploadProgress/started", null, { root: true });
    context.commit("uploadProgress/type", data.data.get("meta").type, {
      root: true
    });
    context.commit(
      "uploadProgress/successMessage",
      "Bild erfolgreich hochgeladen und versendet.",
      { root: true }
    );
    context.commit("uploadProgress/isDialogImage", true, { root: true });
    context.commit("uploadProgress/error", null, { root: true });
    let size = null;
    options.onUploadProgress = event => {
      if (size == null) {
        size = event.total;
        context.commit("uploadProgress/size", size, { root: true });
      }
      let percent = Math.round((100 / event.total) * event.loaded);
      context.commit("uploadProgress/percentage", percent, { root: true });
    };
  }
  return resourceModule.actions
    .oldCreate(context, { ...data, ...{ options } })
    .then(response => {
      let dialogPartner = response.data.receiver;
      dialogPartner.last_message = response.data;
      context.commit("dialog/update", [dialogPartner], { root: true });
      return response;
    })
    .finally(() => {
      context.commit("uploadProgress/finished", null, {
        root: true
      });
    });
};

export const messageModule = resourceModule;
